<app-modal
	class="app-subscription-columns-modal"
	*ngIf="vo$ | async ; let vo">
	<mat-stepper modal-body
							 [linear]="true"
							 [selectedIndex]="vo.currentStep"
							 (selectionChange)="changeCurrentStep($event)"
							 (animationDone)="onStepReady()">
		<mat-step #step1 [completed]="
				(vo.currentStep > ColumnConfigStep.ColumnsSelection && vo.isColumnsReady) ||
				(vo.currentStep === ColumnConfigStep.ColumnsSelection && vo.stepValidity)">
			<ng-template matStepperIcon="edit">
				<mat-icon
					*ngIf="step1.completed">
					done</mat-icon>
			</ng-template>

			<ng-template matStepLabel>
				<span
					i18n="@@subscription.config.stepper.columnsSelection">
					columns-selection</span>
			</ng-template>

			<div class="app-subscription-columns-modal__selection-columns">
				<dc-alert
					class="info"
					type="info"
					message="columns"
					i18n-message="@@subscription.columns.config.stepper.columnsSelection.description">
				</dc-alert>
				<app-panel
					headerHeight="3rem"
					isAlwaysOpen="true"
					hasSearchableGrid="true"
					hasRefresh="true"
					[itemsCount]="vo.availableColumns.size"
					(refresh)="refreshColumns()"
					(search)="columnsSelection.search($event)">
					<span panel-title
						i18n="@@subscription.columns.config.list.title">
						columns</span>
					<div panel-info class="subscription-column-info">
						<ng-container
							*ngIf="vo.error !== undefined  &&
								 vo.error.key === SubscriptionErrorKey.NoSelectColumns">
							<div class="columns-alert error">
								<mat-icon color="warn" [svgIcon]="DcIcons.Warning"></mat-icon>
								<span
									i18n="@@subscription.columns.config.alert.minOneActive">
									min one active column</span>
							</div>
						</ng-container>
					</div>

					<app-columns-config
						id="columns-datablock"
						#columnsSelection="ColumnsGrid"
						[columns]="vo.availableColumns"
						[isInViewMode]="false"
						[columnsConfigMode]="'SELECTION'"></app-columns-config>
				</app-panel>
			</div>
		</mat-step>
		<mat-step [completed]="
				vo.currentStep > ColumnConfigStep.ColumnsProperties ||
				(vo.currentStep === ColumnConfigStep.ColumnsProperties && vo.stepValidity)">
			<ng-template matStepLabel>
				<span
					i18n="@@subscription.config.stepper.columnsProperties">
					columns-properties</span>
			</ng-template>

			<app-panel
				headerHeight="3rem"
				isAlwaysOpen="true"
				hasSearchableGrid="true"
				hasRefresh="true"
				[itemsCount]="vo.subscriptionColumns.size"
				[actions]="vo.columnsPanelActions"
				(refresh)="refreshColumns()"
				(search)="columnsProperties.search($event)">
				<span panel-title
					i18n="@@subscription.columns.config.list.title">
					columns</span>
				<div panel-info class="subscription-column-info">
					<ng-container
						*ngIf="vo.error !== undefined &&
							vo.error.key === SubscriptionErrorKey.InvalidSubscriptionColumns">
						<div class="columns-alert error">
							<mat-icon [svgIcon]="DcIcons.Warning"></mat-icon>
							<span
								i18n="@@subscription.columns.config.alert.invalidColumns">
								invalid columns</span>
						</div>
					</ng-container>
				</div>

				<app-columns-config
					id="columns-properties"
					#columnsProperties="ColumnsGrid"
					[columns]="vo.subscriptionColumns"
					[isInViewMode]="false"
					[columnsConfigMode]="'PARAMETER'"></app-columns-config>
			</app-panel>

		</mat-step>
	</mat-stepper>

	<div modal-footer
		class="app-subscription-columns-modal__footer">
		<div *ngIf="vo.error" class="error-alert error">
			<mat-icon
				[ngClass]="{ 'warning': vo.error.type === 'warning' }"
				color="warn"
				[svgIcon]="vo.error.type === 'critic'? DcIcons.Error: DcIcons.Warning"></mat-icon>
			<span>{{vo.error.message}}</span>
		</div>

		<button
			*ngIf="vo.currentStep === ColumnConfigStep.ColumnsSelection"
			id="{{ cmpId }}-next-btn"
			class="app-exposition-stepper__footer-btn"
			mat-raised-button
			[disabled]="!vo.stepValidity"
			(click)="nextStep()"
			color="primary">
			<span i18n="@@general.stepper.next">Next</span>
		</button>

		<button
			*ngIf="vo.currentStep === ColumnConfigStep.ColumnsProperties"
			id="{{ cmpId }}-back-btn"
			mat-raised-button
			[disabled]="!vo.isColumnsReady"
			(click)="backStep()">
			<span i18n="@@general.stepper.back">Back</span>
		</button>

		<button
			*ngIf="vo.currentStep === ColumnConfigStep.ColumnsProperties"
			id="{{ cmpId }}-update-btn"
			[disabled]="!vo.stepValidity"
			[color]="'primary'"
			mat-raised-button
			(click)="updateSubscriptionColumns()">
			<span
				i18n="@@general.action.update">
				update</span>
		</button>
	</div>
</app-modal>
